import StyledInputField from './StyledInputField';

export default StyledInputField;
